import { graphql, useStaticQuery } from 'gatsby'

type Link = {
	link: string
}

interface PageLinksDataType {
	newsArchive: Link
	homepage: Link
	sectorArchive: Link
	basket: Link
	checkout: Link
	login: {
		link: '/login'
	}
	myAccount: {
		link: '/my-account'
	}
}

export const usePageLinks = () => {
	const data = useStaticQuery<PageLinksDataType>(graphql`
		query getPageLinks {
			newsArchive: wpPage(isPostsPage: { eq: true }) {
				link
			}
			homepage: wpPage(isFrontPage: { eq: true }) {
				link
			}
			sectorArchive: wpPage(template: { templateName: { eq: "Archive Sectors" } }) {
				link
			}
			basket: wpPage(databaseId: { eq: 7 }) {
				link
			}
			checkout: wpPage(databaseId: { eq: 8 }) {
				link
			}
		}
	`)

	// Manually assign some of the woocommerce pages that don't have set pages
	data.login = {
		link: '/login',
	}

	data.myAccount = {
		link: '/my-account',
	}

	data.checkout = {
		link: '/checkout',
	}

	data.basket = {
		link: '/basket',
	}

	// override homepage link
	data.homepage = {
		link: '/',
	}

	return data
}
